import { Box, Icon, Link, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

import sfAuth from "~/auth/SFAuth";
import { BodyText, TitleText } from "~/components/Typographies";
import MultiFactorEnrollContent from "~settings/security/components/MultiFactorEnrollContent";
import useMultiFactorEnrollFlow from "~settings/security/hooks/useMultiFactorEnrollFlow";
import useMultiFactorMutations from "~settings/security/hooks/useMultiFactorMutations";

interface MfaEnforcementInterstitialProps {
	onEnrolled: () => void;
}

const MfaEnforcementInterstitial = ({ onEnrolled }: MfaEnforcementInterstitialProps) => {
	const { t } = useTranslation("common");
	const { completeEnrollment, startEnrollment } = useMultiFactorMutations();
	const flow = useMultiFactorEnrollFlow({
		active: true,
		completeEnrollment,
		fallbackErrorMessage: t("preferences.security.enroll.genericError"),
		startEnrollment
	});

	return (
		<Box
			sx={{
				alignItems: "center",
				bgcolor: "background.default",
				display: "flex",
				height: "100%",
				justifyContent: "center",
				overflow: "auto",
				p: 3,
				width: "100%"
			}}
		>
			<Paper elevation={2} sx={{ maxWidth: 480, p: 4, width: "100%" }}>
				<Box sx={{ alignItems: "center", display: "flex", gap: 1, mb: 2 }}>
					<Icon color="warning">shield</Icon>
					<TitleText sx={{ mb: 0 }}>{t("shell.mfaInterstitial.title")}</TitleText>
				</Box>
				<BodyText color="text.secondary" sx={{ mb: 3 }}>
					{t("shell.mfaInterstitial.description")}
				</BodyText>
				<MultiFactorEnrollContent {...flow} onDone={onEnrolled} />
				<Box sx={{ mt: 3 }}>
					<Link component="button" onClick={() => sfAuth.redirectToLogout()} type="button">
						{t("shell.mfaInterstitial.signOut")}
					</Link>
				</Box>
			</Paper>
		</Box>
	);
};

export default MfaEnforcementInterstitial;
